import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import { checkTokenExpired } from './contexts/AuthContext'

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => {
    const { token, user } = checkTokenExpired(localStorage.getItem('token'))
    if (token && user) {
      return {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      }
    }
    return { headers }
  })
  return forward(operation)
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.error({ graphQLErrors })
  }
  if (networkError) {
    console.error({ networkError })
    // if (networkError.statusCode === 401) {
    //   removeToken()
    // }
  }
})

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_SERVER,
})

const client = new ApolloClient({
  link: from([errorLink, authMiddleware, httpLink]),
  cache: new InMemoryCache(),
})

export default client
